import styled from '@emotion/styled';
import * as React from 'react';
import { colors, fontWeight } from '~/styles/constants';
import Icon, { IconProps } from './Icon';

const Badge = styled.div<{ badgeSize?: string; iconSize?: string }>`
  position: absolute;
  width: ${({ badgeSize }) => badgeSize || '1.5rem'};
  height: ${({ badgeSize }) => badgeSize || '1.5rem'};
  top: ${({ iconSize }) => (iconSize ? `calc(${iconSize} / 1.75)` : 'calc(20px / 1.5)')};
  left: ${({ iconSize }) => (iconSize ? `calc(${iconSize} / 1.75)` : 'calc(20px / 1.5)')};
  background-color: ${colors.white};
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
  box-sizing: ${({ badgeSize }) => (badgeSize ? 'border-box' : 'initial')};

  display: flex;
  flex-direction: column;
  justify-content: center;
  border: 1px solid ${colors.gray100};
  border-radius: 50%;
  text-align: center;
  font-weight: ${fontWeight.medium};
  font-size: 0.875rem;
  line-height: 1.5rem;
  color: ${colors.gray1000};
`;

type WithCountProps = {
  badgeSize?: string;
  count?: number;
};

const IconWithCount = ({
  src,
  alt,
  size,
  count,
  badgeSize,
  className,
}: IconProps & WithCountProps) => {
  return (
    <Icon size={size} className={className} alt={alt} src={src}>
      {!!count && (
        <Badge iconSize={size} badgeSize={badgeSize}>
          {count}
        </Badge>
      )}
    </Icon>
  );
};

const ComposedIconWithCount = React.memo(IconWithCount);

export default ComposedIconWithCount;
